import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "update-notification w-full h-auto",
  style: {"z-index":"1000"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-black" }, "Un nuovo aggiornamento è disponibile.", -1)
const _hoisted_3 = { class: "flex" }

import {getCurrentInstance, onBeforeUnmount, onMounted, ref} from "vue";
  import {useColorMode} from "@vueuse/core";
  import Menu from '@/components/layout/Menu.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let mode = useColorMode();
  const isUpdateAvailable = ref(false);
  const instance = getCurrentInstance();
  const navStore = instance?.appContext.config.globalProperties.$navStore;

  function handleBeforeUnload(event: Event) {
    event.preventDefault();
  }

  onMounted(() => {
    mode.value = 'dark';
    // window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('swUpdated', handleServiceWorkerUpdate);
  });

  onBeforeUnmount(() => {
    // window.removeEventListener('beforeunload', handleBeforeUnload);
    document.removeEventListener('swUpdated', handleServiceWorkerUpdate);
  });

  const reloadPageWithBypassCache = () => {
    window.location.href = window.location.href.split('?')[0] + '?nocache=' + new Date().getTime();
  };

  const handleServiceWorkerUpdate = (event: Event) => {
    const customEvent = event as CustomEvent;
    if (customEvent.detail) {
      isUpdateAvailable.value = true;
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isUpdateAvailable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("button", {
            onClick: reloadPageWithBypassCache,
            class: "text-black"
          }, "Aggiorna")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_unref(navStore).nav)
        ? (_openBlock(), _createBlock(Menu, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})